module.exports = __webpack_public_path__ + "static/media/logo-card.d1cdd0f6.png";